import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import { FocusStyleManager } from "@blueprintjs/core";
import App from "./App";

// 👇 NEW – bring in the context provider you created in Step 1-a
import { AuthProvider } from "./auth/AuthContext";
import { OrgProvider } from "./auth/OrgContext";
import { ProjectProvider } from "./auth/ProjectContext";

// Configure Blueprint focus rings (only on Tab)
FocusStyleManager.onlyShowFocusOnTabs();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* 👇 NEW – one global place for login + subscription state */}
      <AuthProvider>
        <OrgProvider>
          <ProjectProvider>
            <App />
          </ProjectProvider>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
